
import logUtil from "../utils/log-utils";
import { utils } from "@utils/utils";

function init(){
	window.onerror = function(message, filename, lineno, colno, error){
		const logType = "RuntimeError";
		const appName = `${window.xkwTracker.$product || "未知产品"} - ${ window.xkwTracker.$application || "未知应用"}`;
		const time = utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
		const userId = window.xkwTracker.$user_id || "未知用户";
		const url = window.location.href;
		const userAgent = window.navigator.userAgent;
		const logString = [message,JSON.stringify(error),filename,lineno,colno].join("------");
		let errorContent = [logType, appName, time, userId, url, userAgent, logString];
		logUtil.writeLog(errorContent);
	};
	// window.addEventListener("error", function(errorEvent){
	// 	const {filename,lineno,colno,type,error:{message,stack}} = errorEvent;
	// 	console.log("error",errorEvent);
	// 	const logType = "RuntimeError";
	// 	const appName = window.xkwTracker.$application || "未知应用";
	// 	const time = utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
	// 	const userId = window.xkwTracker.$$user_id || "未知用户";
	// 	const url = window.location.href;
	// 	const userAgent = window.navigator.userAgent;
	// 	const logString = [message,stack,filename,lineno,colno,type].join("------");
	// 	let errorContent = [logType, appName, time, userId, url, userAgent, logString];
	// 	logUtil.writeLog(errorContent);
	// });
}

export default {
	init
};